import MeetingTypeSelector from './MeetingTypeSelector';

export default MeetingTypeSelector;
